module.exports = __webpack_public_path__ + "static/img/wts.81a5153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/wts.png
// module id = ZLpZ
// module chunks = 0